module.exports = __webpack_public_path__ + "img/rhythmProcess1.c3acf31a.png";